<template>
  <Suspense>
    <router-view />
  </Suspense>
</template>
